var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Summit--Streamline-Sharp",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Summit Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "summit--shop-target-flag-summit-mountain-goal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2787",
    stroke: "#fff",
    d: "M1.0418 22.9582L11.7327 10.1291L22.9582 22.9582",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2788",
    stroke: "#fff",
    d: "M11.7327 10.1291V6.3873M11.7327 6.3873V1.0418H19.2164V6.3873H11.7327Z",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2789",
    stroke: "#fff",
    d: "M6.3873 15.4745L9.5945 18.6818L11.7327 16.5436L13.8709 18.6818L17.0782 15.4745",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunish);
export default __webpack_public_path__ + "static/media/FUNISH.15b13f27a2ada83d1ae429cf4229297b.svg";
export { ForwardRef as ReactComponent };